<template>
    <div class="row panel-body">
        <form method="post" ref="form">
            <input type="hidden" name="_token" :value="csrfToken" />
            <div class="row"><br /></div>

            <div class="row">
                <div class="col-xs-5">
                    <label for="lesson-title-translation">
                        <h2>{{ masterTitle }}</h2></label>
                </div>
                <div class="col-xs-7">
                    <div :class="{ 'has-error': newTitle.trim() === '' }">
                        <h2>
                            <input class="form-control"
                                   style="color:black"
                                   type="text"
                                   @keyup="setCanSubmit()"
                                   placeholder="Translated Lesson Title"
                                   name="lesson_title"
                                   :required="true"
                                   v-model="newTitle"
                                   tabindex="1"
                                   autofocus
                                   id="lesson-title-translation" />
                        </h2>

                        <span class="help-block" v-if="newTitle.trim() === ''">
                            The title cannot be empty!
                        </span>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-1">
                    <h4>Time</h4>
                </div>
                <div class="col-xs-4">
                    <h4>Master Cues</h4>
                </div>

                <div class="col-xs-7">
                    <h4>Translation</h4>
                </div>
            </div>

            <div class="row" v-for="(cue, number) in masterCues">
                <div class="col-xs-1">
                    <span style="line-height: 2em;">{{ timestamps[number] }}</span>
                </div>
                <div class="col-xs-4">
                    <p style="padding-bottom: 5px; line-height: 2em;" v-html="cue"></p>
                </div>

                <div class="col-xs-7">
                    <subtitle-cue-textarea
                            ref="cuetext"
                            @subtitleCueTextAreaUpdated="setCanSubmit()"
                            :lines="workInProgress[number]"
                            :name="'edits['+number+']'"
                            :disabled="isDisabled(number)"
                            :required="'required'"
                    ></subtitle-cue-textarea>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-6">
                    <button class="btn btn-default"
                            name="submit-save"
                            @click.prevent="save('Saved')">
                        <strong>Save</strong>
                    </button>
                </div>

                <div class="col-xs-6 text-right">
                    <submit-button :disabled="!canSubmit"
                                   :title="canSubmit ? 'Submit' : 'Some cues have errors'"></submit-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    let toastr = require('toastr')

    export default {
        props: [
            'masterTitleJson',
            'newTitleJson',
            'timestampsJson',
            'masterCuesJson',
            'cuesToCorrectJson',
            'workInProgressJson',
            'saveRoute',
        ],

        data: function() {
            return {
                csrfToken: window.csrfToken,
                canSubmit: true,
                newTitle: '',
                autosaveCache: '',
            }
        },

        computed: {
            masterTitle: function() {
                return JSON.parse(this.masterTitleJson)
            },
            masterCues: function() {
                return JSON.parse(this.masterCuesJson)
            },
            workInProgress: function() {
                return JSON.parse(this.workInProgressJson)
            },
            cuesToCorrect: function() {
                return JSON.parse(this.cuesToCorrectJson)
            },
            timestamps: function() {
                return JSON.parse(this.timestampsJson)
            },
        },

        mounted() {
            this.autosaveCache = $(this.$refs.form).serialize();
            this.autosaveTimer()
            this.newTitle = JSON.parse(this.newTitleJson)
            this.setCanSubmit()
        },

        methods: {
            setCanSubmit() {
                if (this.newTitle.trim() === '') {
                    this.canSubmit = false
                    return
                }
                for (let index in this.$refs.cuetext) {
                    if (!this.$refs.cuetext[index].isValid) {
                        this.canSubmit = false
                        return
                    }
                }
                this.canSubmit = true
            },

            isDisabled(cueNumber) {
                if (this.cuesToCorrect.length === 0) {
                    return false
                }

                return this.cuesToCorrect.indexOf(cueNumber) === -1
            },

            autosaveTimer() {
                setTimeout(() => {
                    this.autosave()
                    this.autosaveTimer()
                }, 60000) // once per minute
            },

            autosave() {
                // only autosave if form data has changed since last save
                if (this.autosaveCache !== $(this.$refs.form).serialize()) {
                    this.save('Auto saved');
                }
            },

            save(message) {
                let formData = $(this.$refs.form).serialize()

                window.axios.post(this.saveRoute, formData).then(() => {
                    this.autosaveCache = formData;
                    toastr.success(message)
                }).catch(() => {
                    toastr.error('Something went wrong...', message)
                })
            },
        },
    }
</script>
